import { useEffect, useRef, useState } from "react";

/**
 * Board M-R1 (13 Strategy, "the live line changes"): one line that is replaced,
 * never added to, and changes at most once a second; faster steps are skipped
 * and the latest one wins. `key` changes with each swap so the line re-mounts
 * and its arrival animation runs; `swapping` is false for the first line.
 */
export function useLiveLine(text: string): { text: string; key: number; swapping: boolean } {
  const [shown, setShown] = useState({ text, key: 0 });
  const lastSwap = useRef(0);
  const pending = useRef<number | null>(null);

  useEffect(() => {
    if (text === shown.text) return;
    const wait = Math.max(0, 1000 - (Date.now() - lastSwap.current));
    if (pending.current !== null) window.clearTimeout(pending.current);
    pending.current = window.setTimeout(() => {
      pending.current = null;
      lastSwap.current = Date.now();
      setShown((previous) => ({ text, key: previous.key + 1 }));
    }, wait);
    return () => {
      if (pending.current !== null) window.clearTimeout(pending.current);
    };
  }, [text, shown.text]);

  return { text: shown.text, key: shown.key, swapping: shown.key > 0 };
}
